export function selectCurrentPage(thisEventData, slug) {

  if (!thisEventData || thisEventData && !thisEventData.template.templateSchema || thisEventData && thisEventData.template.templateSchema && !thisEventData.template.templateSchema.pages) return '';

  const {
    pages
  } = thisEventData.template.templateSchema;

  let currentPage;
  let homePage;

  const thisSlug = slug ? slug : thisEventData.pageSlug;


  for (let i = 0; i < pages.length; i++) {

    if (!pages[i].slug) continue;

    if (pages[i].slug === '/' || !thisSlug && pages[i].slug === '/') {
      homePage = pages[i];
    }

    if (!thisSlug && pages[i].slug === '/' || pages[i].slug === thisSlug) {
      currentPage = pages[i];
      break;
    }
  }
  
  return currentPage ? currentPage : '';
}